
 <form [formGroup]="formGroup">
  <mat-form-field class="entity">
    <input
      type="text"
      #entity
      matInput
      placeholder="Entidad"
      formControlName="Entity"
      required
      [matAutocomplete]="autEntity"
    />
    <mat-autocomplete
      #autEntity="matAutocomplete"
      [displayWith]="filterCompleteEntity.displayFn"
    >
      <mat-option
        *ngFor="let entity of filterCompleteEntityOptions | async"
        [value]="entity"
      >
        {{ entity.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="plan">
    <input
      type="text"
      #plan
      matInput
      placeholder="Plan"
      formControlName="Plan"
      required
      [matAutocomplete]="planAutocomplete"
    />
    <mat-autocomplete
      #planAutocomplete="matAutocomplete"
      [displayWith]="filterCompletePlan.displayFn"
    >
      <mat-option
        *ngFor="let plan of filterCompletePlanOptions | async"
        [value]="plan"
      >
        {{ plan.Name }}
      </mat-option></mat-autocomplete
    >
  </mat-form-field>



</form>
